import * as React from 'react';
import { Modal } from './Modal';
import { Autocomplete, Button, TextField, Typography } from '@mui/material';
import { AlertProps } from '@mui/material/Alert';
import { Product, getProducts } from '../types/Product';
import { useNavigate, useParams } from 'react-router-dom';
import { httpGet, httpPost } from '../Web';
import { Workshop, getWorkshops } from '../types/Workshop';
import { httpGetIds } from '../Utils';
import { WorkshopProduct } from '../types/WorkshopProducts';
import { WorkshopProductImport, importWorkshopProductSettings } from '../types/WorkshopTestCases';
import { UserContext } from '../UserProvider';
import { Company } from '../types/Company';
import { DataGrid, GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';

import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import { FeatureNotAvailableIcon } from '../subs/FeatureNotAvailableIcon';
import { useSnackbar } from '../../contexts/SnackBarContext';
//import { deleteWorkshopProductProperties, getWorkshopProductProperties, updateWorkshopProductProperties } from '../types/WorkshopProductProperty';

const getWorkshopProducts = async (abortController: AbortController): Promise<WorkshopProduct[]> => {
    try {
        let workshops = await getWorkshops(abortController);
        let workshopIds = workshops.result.map((ws: Workshop) => ws.id);

        let workshopProductRequests = await httpGetIds('/api/workshopproduct', workshopIds);

        console.log('pr: ', workshopProductRequests);
        return workshopProductRequests.flatMap(wpr => wpr.result);
    } catch(error) {
        console.error('getWorkshopProducts: ', error);
        return Promise.reject();
    }
}

const updateWorkshopProduct = async(workshopProduct: WorkshopProduct, abortController: AbortController) => {
    try {
        const readback = await httpPost(`/api/workshopproduct/update`, workshopProduct, abortController);
        console.info('readback: ', readback);

        return readback;
    } catch(error) {
        console.error('error: ', error);

        return Promise.reject();
    }
}

/*const importWPFromPreviousWorkshopHandler = async(currentInstance: WorkshopProduct, previousInstance: WorkshopProduct) => {
    //create a copy of the WorkshopProduct instance from the previous workshop
    //replace id, guid, workshopId fields inside the copy with the fields of the instance from the current workshop
   /* const newCurrentInstance = {...previousInstance};
    
    newCurrentInstance.id = currentInstance.id;
    newCurrentInstance.guid = currentInstance.guid;
    newCurrentInstance.workshopId = currentInstance.workshopId;
    newCurrentInstance.productId = currentInstance.productId;

    console.info('property deletion response: ', getWorkshopProductProperties(currentInstance.id, new AbortController())
    .then(response => response.result.map(wp => wp.id))
    .then(ids => deleteWorkshopProductProperties(ids as number[])));
    
    console.info('property update response: ', getWorkshopProductProperties(previousInstance.id, new AbortController())
    .then(response => response.result.map(wpp => { return {...wpp, id: undefined, guid: undefined, workshopProductId: newCurrentInstance.id }}))
        .then(wpp => updateWorkshopProductProperties(wpp)));* /
    const workshopProductImport: WorkshopProductImport = {
        workshopProductIdFrom: previousInstance.id,
        workshopProductIdTo: currentInstance.id
    };

    const importSettingsResponse = await importWorkshopProductSettings(workshopProductImport, new AbortController());

    if (importSettingsResponse.failed) {
      //  showUserFeedback(importSettingsResponse.errorText);
        return;
    }
    const importSettingsResult = importSettingsResponse.result;

    if (workshopProductImport.workshopProductIdFrom !== importSettingsResult.workshopProductIdFrom ||
        workshopProductImport.workshopProductIdTo !== importSettingsResult.workshopProductIdTo) {
        // showUserFeedback('Import did not complete successfully.');
        return;
    }



 /*
  use previousInstance to get test cases
  then update ids in each to currentInstance id
  then call updateWSProductTestcases with the modified test cases

 export const getWSProductTestcases = (workshopProductId: number, abortController: AbortController): Promise<ApiResponse<WorkshopTestCase[]>> =>
    httpGet(`/api/workshopproduct/workshoptestcases/${workshopProductId}`, abortController);

export const getWSProductTestcasesAsync = async (workshopProductId: number, abortController: AbortController): Promise<ApiResponse<WorkshopTestCase[]>> => {
    return httpGet(`/api/workshopproduct/workshoptestcases/${workshopProductId}`, abortController);
}

export const updateWSProductTestcase = async (workshopProductProperty: WorkshopTestCase) => {
    return httpPost('/api/workshopproduct/workshoptestcase/update', workshopProductProperty, new AbortController())
}

export const updateWSProductTestcases = async (workshopProductProperties: WorkshopTestCase[]) => {
    return Promise.all(workshopProductProperties.map(wpp => updateWSProductTestcase(wpp)));
    * /

    //delete all properties of the current instance
    //1. get ids of all current properties
    //2. delete current properties by 
    
    //insert all properties of the previous instance as properties of the new current
    //1. get all properties of the previous instance
    //2. remove ids, guids, replace workshopProductId with id of current instance
    //3. update

   // return updateWorkshopProduct(newCurrentInstance, new AbortController());   
}*/

export const ImportWorkshopProductModal = () => {
    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();

    const userContext = React.useContext(UserContext);

    const { workshopId, currentWorkshopProductId, givenProductID } = useParams();

    const [userCompanyId, setuserCompanyId] = React.useState<Number>();
    const [companyProducts, setCompanyProducts] = React.useState<Product[]>([]);
    const [sourceProductId, setSourceProductId] = React.useState<Number>();
    const [sourceProduct, setSourceProduct] = React.useState<Product | null>();
    const [productSelectDisabled, setproductSelectDisabled] = React.useState<boolean>(true);

    const [workshopProducts, setWorkshopProducts] = React.useState<WorkshopProduct[]>([]);
    const [currentWorkshopProduct, setcurrentWorkshopProduct] = React.useState<WorkshopProduct>();
    const [workshops, setWorkshops] = React.useState<Workshop[]>([]);

    const showUserFeedback = React.useCallback((msg: string | null, severity: AlertProps['severity'] = 'error') => {
        msg && showSnackbar(msg, severity);
    }, [showSnackbar]);

    console.log('WorkshopId: ', workshopId);

    React.useEffect(() => {
        getWorkshops(new AbortController()).then(wq => setWorkshops(wq.result));
        console.log('Workshops: loaded');
    }, []);

    React.useEffect(() => {
        async function getCompanies() {
            let companies = await httpGet('/api/company', new AbortController());

            if (companies.failed) {
                //  setError(productsResponse.errorText)
                return;
            }

            const userCompanyIdLoc = companies.result.find((company: Company) => userContext.user.companyName === company.name).id;

            setuserCompanyId(userCompanyIdLoc);
        }

        getCompanies();
    }, [userContext.user.companyName]);

    React.useEffect(() => {
        async function getCompanyProducts() {
            const productsResponse = await getProducts(new AbortController());

            if (productsResponse.failed) {
                showUserFeedback(productsResponse.errorText)
                return;
            }

            const cmpnyProds = productsResponse.result.filter(product => product.companyId === userCompanyId);
            setCompanyProducts(cmpnyProds);
        }

        getCompanyProducts();
    }, [userCompanyId]);

    React.useEffect(() => {
        const givenID = Number(givenProductID ?? 0);
        setproductSelectDisabled(givenID ? true : false);
        setSourceProductId(givenID);
    }, [givenProductID]);

    React.useEffect(() => {
        if (sourceProductId === undefined || sourceProductId === 0) {
            setSourceProduct(null);
        }
        else httpGet(`/api/product/get/${sourceProductId}`, new AbortController()).then(query => setSourceProduct(query.result));
    }, [sourceProductId]);

    React.useEffect(() => {
        getWorkshopProducts(new AbortController()).then(wps => {
            setcurrentWorkshopProduct(wps.filter(wp => (wp.id === Number(currentWorkshopProductId)))[0]);
            setWorkshopProducts(wps.filter(wp => (wp.productId === sourceProduct?.id && wp.id !== Number(currentWorkshopProductId))));
        });
    }, [currentWorkshopProductId, sourceProduct]);

    const importWPFromPreviousWorkshopHandler = async (currentInstance: WorkshopProduct, previousInstance: WorkshopProduct) => {
        const workshopProductImport: WorkshopProductImport = {
            workshopProductIdFrom: previousInstance.id,
            workshopProductIdTo: currentInstance.id
        };

        const importSettingsResponse = await importWorkshopProductSettings(workshopProductImport, new AbortController());

        if (importSettingsResponse.failed) {
            showUserFeedback(importSettingsResponse.errorText);
            return;
        }
        const importSettingsResult = importSettingsResponse.result;

        if (workshopProductImport.workshopProductIdFrom !== importSettingsResult.workshopProductIdFrom ||
            workshopProductImport.workshopProductIdTo !== importSettingsResult.workshopProductIdTo) {
            showUserFeedback('Import did not complete successfully.');
            return;
        }

        showUserFeedback('Import completed successfully.', 'success');
    }

    const columns: GridColDef[] = [{
        field: 'workshop',
        headerName: 'Workshop',
        valueGetter: (value, row) => {
            return workshops.find(ws => ws.id === row.workshopId)?.name;
        },
        flex: 4,
    },
    {
        field: 'version',
        headerName: 'Version',
        valueGetter: (value, row) => {
            return row.productVersion;
        },
        flex: 4
    },
    {
        field: 'isServer',
        headerName: 'Server?',
        valueGetter: (value, row) => {
            return row.isServer;
        },
        renderCell: (params) => params.row.isServer ? <CheckBoxIcon /> : <FeatureNotAvailableIcon />,
        flex: 1,
    },
    {
        field: 'isClient',
        headerName: 'Client?',
        valueGetter: (value, row) => {
            return row.isClient;
        },
        renderCell: (params) => params.row.isClient ? <CheckBoxIcon /> : <FeatureNotAvailableIcon />,
        flex: 1
    }
    ];

    const [selectionModel, setSelectionModel] = React.useState<GridRowSelectionModel>([]);

    return <Modal title={`Previous instances of ${sourceProduct?.name!!}`} description={[
        <Typography variant='body2'>{'Import instances from previous workshops intothe current workshop'}</Typography>,
        <Typography variant='bold'>{'Warning: This import will overwrite all currently specified product data!'}</Typography>]} cancel
        buttons={[<Button disabled={selectionModel.length === 0} startIcon={<ImportExportIcon />}
            onClick={() => {
                importWPFromPreviousWorkshopHandler(currentWorkshopProduct!!, workshopProducts.find(wp => wp.id === selectionModel[0])!!);
                navigate(-1);
            }/*error handling?*/}>
            {'Import'}
        </Button>]}>

        <Autocomplete id='ProductName' options={companyProducts ?? []} value={sourceProduct} hidden={productSelectDisabled}
            renderInput={(params) => <TextField multiline {...params} label={"Product name"} />}
            renderOption={(props, product) => {
                return (
                    <li {...props} key={product.id}>
                        {product.name}
                    </li>
                );
            }}
            getOptionLabel={product => product.name}
            onChange={(event, value) => { setSourceProduct(value) }} />

        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <DataGrid
                sx={{
                    "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer": {
                        display: "none"
                    },
                }}

                slots={{
                    // **** REMOVED TO GET IT TO COMPILE **** // baseCheckbox: Radio
                }}

                columns={columns} rows={workshopProducts} rowSelectionModel={selectionModel}
                checkboxSelection disableColumnMenu hideFooter showCellVerticalBorder

                onRowSelectionModelChange={(newRowSelectionModel) => {
                    if (newRowSelectionModel.length === 0)
                        setSelectionModel(newRowSelectionModel);
                    else {
                        const selectionSet = new Set(selectionModel);
                        const result = newRowSelectionModel.filter((s) => !selectionSet.has(s));

                        setSelectionModel(result);
                        console.log(selectionModel);
                    }
                }}

                getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'}
            />
        </div>
    </Modal>
}